// extracted by mini-css-extract-plugin
export default {"RootLayout":"RootLayout_RootLayout__d7rMM","ContentContainer":"RootLayout_ContentContainer__UMr1E"};